import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiCompanyService
    ,FvmsApiDtgTeamService
    ,FvmsApiAuthService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";

@Component({
    selector: "[dtg-manage-company-list]"
    ,templateUrl: './dtg.manage.company.list.component.html'
    ,providers: []
})
export class DtgManageCompanyListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    dtgTeamId:string = "";
    currentUserInfo:any;
    userGroupId:number;
    pagingInfo:PagingInfo = new PagingInfo();
    @Input() listType:DtgListType = DtgListType.list;
    @Output() outCompanyInfo = new EventEmitter();
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;
    searchInfo:any = {
        companyId:""
        ,searchValue:""
    };
    listItem:any;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiCompanyService:FvmsApiCompanyService
        ,private fvmsApiDtgTeamService:FvmsApiDtgTeamService
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.pagingInfo.pageSize = 15;
        this.searchInfo.companyId = this.companyInfo.companyId;

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.pagingInfo.curPage = 1;
                this.searchInfo.companyId = companyInfo.companyId;
                this.reloadListItem();
            });
     }

    ngOnInit() {
        this.reloadListItem();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    clickSearch(){
        this.reloadListItem();
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.reloadListItem();
    }

    reloadListItem(){
        this.fvmsApiCompanyService.getListCompanyTreeRecursive(this.searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(response => {
                if(response.resultStatus === "ok"){
                    this.listItem = response.resultValue;
                    this.pagingInfo = response.pagingInfo;
                }
            });
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    clickSelectCompany(companyInfo){
        this.outCompanyInfo.emit(companyInfo);
    }
}